import { useIsDesktop } from '@/components/user-context/helpers/cohorts';

// Should be removed once AI is extended to mobile
export const useAiSearchEnabled = (): boolean => useIsDesktop() ?? false;
